import { render, staticRenderFns } from "./PersonMedicalDataComponent.vue?vue&type=template&id=8fd4d994"
import script from "./PersonMedicalDataComponent.vue?vue&type=script&lang=js"
export * from "./PersonMedicalDataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports